<template>
  <div v-if="isDisplayTheModule">
      <slot></slot>
  </div>
</template>

<script>
import { thirdPartModuleConfig } from '@/../config/moduleConfig'
export default {
  name: 'ModuleContainer',
  computed: {
    isDisplayTheModule () {
      const moduleConfig = thirdPartModuleConfig[process.env.NODE_ENV] || thirdPartModuleConfig['viteusa']
      return this.moduleNames.every(name => moduleConfig.includes(name))
    }
  },
  props: {
    moduleNames: {
      type: Array,
      required: true
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/ModuleContainer.vue